module.exports = __webpack_public_path__ + "static/logo-70da0dba5d87005843f6fca05fa45ace.png";